import { render, staticRenderFns } from "./bpmDeputySetting.vue?vue&type=template&id=445a27b0&scoped=true&"
import script from "./bpmDeputySetting.vue?vue&type=script&lang=js&"
export * from "./bpmDeputySetting.vue?vue&type=script&lang=js&"
import style0 from "./bpmDeputySetting.vue?vue&type=style&index=0&id=445a27b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a27b0",
  null
  
)

export default component.exports